import React from 'react';
export function ObjectionBreaker() {
  return <section className="py-16 px-4 max-w-4xl mx-auto" data-id="element-118">
      <div className="text-center mb-10" data-id="element-119">
        <span className="text-5xl mb-4 block" data-id="element-120">⚠️</span>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-121">
        <div className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8" data-id="element-122">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-123">
            <span className="text-brand-green mr-3" data-id="element-124">✅</span> Esto es para ti
            si…
          </h3>
          <ul className="space-y-4 text-gray-200" data-id="element-125">
            <li className="flex items-start" data-id="element-126">
              <div className="w-2 h-2 bg-brand-green rounded-full mr-3 mt-2 shrink-0" data-id="element-127"></div>
              <span data-id="element-128">Ya sabes enseñar italiano pero no logras escalar</span>
            </li>
            <li className="flex items-start" data-id="element-129">
              <div className="w-2 h-2 bg-brand-green rounded-full mr-3 mt-2 shrink-0" data-id="element-130"></div>
              <span data-id="element-131">Te sientes atrapado en el 1 a 1</span>
            </li>
            <li className="flex items-start" data-id="element-132">
              <div className="w-2 h-2 bg-brand-green rounded-full mr-3 mt-2 shrink-0" data-id="element-133"></div>
              <span data-id="element-134">Quieres más libertad sin dejar lo que sabes</span>
            </li>
          </ul>
        </div>

        <div className="bg-brand-red/10 border border-brand-red/30 rounded-2xl p-8" data-id="element-135">
          <h3 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-136">
            <span className="text-brand-red mr-3" data-id="element-137">❌</span> Y NO es para ti si:
          </h3>
          <ul className="space-y-4 text-gray-200" data-id="element-138">
            <li className="flex items-start" data-id="element-139">
              <div className="w-2 h-2 bg-brand-red rounded-full mr-3 mt-2 shrink-0" data-id="element-140"></div>
              <span data-id="element-141">Buscas resultados sin hacer nada</span>
            </li>
            <li className="flex items-start" data-id="element-142">
              <div className="w-2 h-2 bg-brand-red rounded-full mr-3 mt-2 shrink-0" data-id="element-143"></div>
              <span data-id="element-144">No estás dispuesto a adaptarte</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}